import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WidgetOrgResolverService } from 'src/app/services/widget-org-resolver.service';
import { DashboardOverrideService } from 'src/app/services/dashboard-override.service';

@Injectable({ providedIn: 'root' })
export class WidgetOrgEffectService {
    constructor(
        private widgetOrgResolver: WidgetOrgResolverService,
        private dashboardOverride: DashboardOverrideService,
    ) {}

    bind(
        widgetConfig$: Observable<Record<string, unknown>>,
        widgetId: string | null | undefined,
        onOrgChange: () => void,
        destroy$: Observable<void>,
    ): void {
        this.widgetOrgResolver.effectiveOrgId$(widgetConfig$)
            .pipe(takeUntil(destroy$))
            .subscribe(() => onOrgChange());

        this.widgetOrgResolver.lostAccess$(widgetConfig$)
            .pipe(takeUntil(destroy$))
            .subscribe(() => {
                if (widgetId != null) this.dashboardOverride.reportLostAccess(widgetId);
            });
    }
}
